import React from 'react';
import PropTypes from 'prop-types';
import { useEnabledFeatureFlag } from '../utils/feature-flagging/FeatureFlagProvider';
import FeatureFlags from '../utils/feature-flagging/FeatureFlags';

const FlaggedButton = (props) => {
  const { flag, ...buttonProps } = props;
  const flagStatus = useEnabledFeatureFlag(FeatureFlags[flag]);
  return flagStatus ? <button {...buttonProps}>{props.children}</button> : null;
};

FlaggedButton.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FlaggedButton;
